interface SubscriptionGateProps {
  accessLevel: 'public' | 'subscribers' | 'premium'
  price?: number | null
  onPurchase?: () => void
}

export default function SubscriptionGate({}: SubscriptionGateProps) {
  // Grid overlay: just a lock icon. Full purchase/subscribe UI is in the lightbox.
  return (
    <div className="absolute inset-0 bg-black/60 backdrop-blur-3xl flex items-center justify-center">
      <svg
        className="w-8 h-8 text-white/80"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
        />
      </svg>
    </div>
  )
}
